import { LOGIN, LOGOUT, UPDATE_USER } from "../constants";
import * as api from "../../services/api";
import Swal from "sweetalert2";

const login = (userData) => async (dispatch) => {
  try {
    const payload = {};
    const authLocal = JSON.parse(localStorage.getItem("user"));
    if (!authLocal) {
      const response = await api.login(userData);
      payload.refreshtoken = response.data?.refresh_token;
      payload._id = response.data.user._id;
      payload.email = response.data.user.email;
      payload.profile = response.data.user.profile;
      payload.name = response.data.user.name;

      if (payload.profile === "recruiter") {
        const response = await api.getRecruiterCompany();
        payload.companyId = response.data.data.companyId;

        // console.log(response);
        // console.log(payload);

        dispatch({
          type: LOGIN,
          payload,
        });
        localStorage.setItem("user", JSON.stringify(payload));
      } else {
        dispatch({
          type: LOGIN,
          payload,
        });
        localStorage.setItem("user", JSON.stringify(payload));
      }
    } else {
      dispatch({
        type: LOGIN,
        payload: userData,
      });
    }
  } catch (error) {
    // console.log("err1", error.response.status);
    if (error.response.data.message === 401) {
      Swal.fire({
        icon: "error",
        text: "Invalid credentials....",
        timer: 1300,
      });
    }
    if (error.response.status === 401) {
      Swal.fire({
        icon: "error",
        text: "Invalid credentials....",
        timer: 1300,
      });
    }
  }
};
const updateUser = () => async (dispatch) => {
  const payload = {};
  try {
    const response = await api.getRecruiterCompany();
    const authLocal = JSON.parse(localStorage.getItem("user"));
    payload.companyId = response.data.data.companyId;
    payload.userId = authLocal._id;

    localStorage.removeItem("user");
    authLocal.companyId = payload.companyId;
    localStorage.setItem("user", JSON.stringify(authLocal));

    dispatch({
      type: UPDATE_USER,
      payload,
    });
  } catch (error) {
    // console.log("err1", error.response.status);
    if (error.response.status === 401) {
      Swal.fire({
        icon: "error",
        text: "Invalid credentials....",
        timer: 1300,
      });
    }
    if (error.response.status === 401) {
      Swal.fire({
        icon: "error",
        text: "Invalid credentials....",
        timer: 1300,
      });
    }
  }
};
const logout = (type) => {
  localStorage.removeItem("user");
  window.location.href = "/";
  // window.location.href = `/hiring/${type}`;
  return {
    type: LOGOUT,
  };
};
const actions = {
  login,
  logout,
  updateUser,
};
export default actions;
